import Vue from 'vue'
import Vuex from 'vuex'

import conversation from './modules/conversation'
import selection from './modules/selection'
import tagsPicker from './modules/tagsPicker'
import transcriptTags from './modules/transcriptTags'
import editor from './modules/editor'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    transcriptTags,
    conversation,
    selection,
    tagsPicker,
    editor
  }
})
